import { useQuery } from "@tanstack/react-query";
import type { FlightState } from "@/features/sky";
import { type LiveResource, toLiveResource } from "@/data/liveResource";
import { config } from "./config";

const fetchFlights = async (): Promise<FlightState[]> => {
  const res = await fetch(config.url);
  if (!res.ok) return [];
  const data = (await res.json()) as { flights?: FlightState[] };
  return data.flights ?? [];
};

export const useFlights = (): LiveResource<FlightState[]> => {
  const query = useQuery({
    queryKey: ["flights"],
    queryFn: fetchFlights,
    refetchInterval: config.refetchMiliseconds,
  });

  return toLiveResource(query, {
    source: () => "adsb.fi",
    freshAt: (flights) =>
      flights.length
        ? new Date(Math.max(...flights.map((f) => f.t)) * 1000)
        : null,
    staleAfterMs: config.staleAfterMiliseconds,
  });
};
